import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="bg-black text-white py-2 px-3 text-center sticky top-0 z-50" data-id="element-318">
      <p className="font-sans font-semibold md:text-xs tracking-wide text-[11px]" data-id="element-319">
        🔥 Launch Special Ends Tonight <span className="mx-1" data-id="element-320">|</span>{' '}
        <span className="text-soft-gold text-[10px]" data-id="element-321">
          Get All 3 Bonuses Free Today
        </span>
      </p>
    </div>;
}